import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchPOSProducts = createAsyncThunk(
  "api/POSProducts/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/POSProducts`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const POSProductsSlice = createSlice({
  name: "POSProducts",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPOSProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPOSProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchPOSProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default POSProductsSlice.reducer;
export const selectPOSProductsRows = (state) => state.POSProducts.rows;
export const selectPOSProductsStatus = (state) => state.POSProducts.status;
export const selectPOSProductsError = (state) => state.POSProducts.error;
